/**
 * @deprecated
 * Cairo now provides lodash mocks automatically
 */
export function mockLodashDebounce(
  _: Pick<typeof import('lodash'), 'debounce' | 'throttle'>,
) {
  jest
    .spyOn(_, 'debounce')
    .mockImplementation(
      (fn: (...args: any[]) => unknown, delay?: number): any => {
        let timeoutId: ReturnType<typeof setTimeout>;
        return function mockDebounce(...args: any[]) {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => fn(...args), delay) as any;
        };
      },
    );

  jest
    .spyOn(_, 'throttle')
    .mockImplementation(
      (fn: (...args: any[]) => unknown, delay?: number): any => {
        let timeoutId: ReturnType<typeof setTimeout> | null;
        return function mockThrottle(...args: any[]) {
          if (timeoutId != null) {
            return;
          }

          timeoutId = setTimeout(() => {
            if (timeoutId != null) {
              clearTimeout(timeoutId);
            }
            timeoutId = null;
            fn(...args);
          }, delay) as any;
        };
      },
    );
}
